{
  "title": "Dashboard",
  "greeting": "Good morning, {{name}}",
  "greetingAnonymous": "Good morning",
  "scope": {
    "onlyMine": "Only mine",
    "workspaceTrigger": "Change workspace",
    "teamTrigger": "Change team",
    "allWorkspaces": "All workspaces",
    "allTeams": "All teams",
    "searchPlaceholder": "Search…",
    "pickerEmpty": "Nothing found"
  },
  "summary": {
    "mine": "{{attention}} things need you · {{shoots}} of your shoots in the next {{days}} days",
    "workspace": "{{attention}} things need attention · {{shoots}} shoots in the next {{days}} days",
    "organization": "{{attention}} things need attention across the organization · {{shoots}} shoots in the next {{days}} days",
    "team": "{{attention}} things need attention in this team · {{shoots}} shoots in the next {{days}} days"
  },
  "sections": {
    "nextShoots": "Next shoots",
    "nextShootsHint": "Readiness of the shoots closest to today",
    "attention": "Needs attention",
    "attentionHint": "Most urgent first; rows disappear once the work is done",
    "pulse": "Pulse",
    "pulseHint": "Next {{days}} days",
    "timeline": "Next {{days}} days",
    "timelineHint": "Shoot dates lane by lane; point at a bar for crew and status",
    "workspaces": "Workspaces",
    "workspacesHint": "Where the work and the risk sit right now"
  },
  "shoot": {
    "open": "Open production",
    "untitled": "Untitled production",
    "crewMeter": "Crew booked",
    "callsheetMeter": "Callsheet",
    "callsheet_shared": "Shared",
    "callsheet_building": "Building",
    "callsheet_missing": "Not started"
  },
  "status": {
    "active": "Shooting",
    "ready": "Ready",
    "resourcing": "Resourcing",
    "alert": "At risk",
    "draft": "No roles yet",
    "complete": "Wrapped"
  },
  "when": {
    "today": "Today",
    "tomorrow": "Tomorrow",
    "inDays_one": "in {{count}} day",
    "inDays_other": "in {{count}} days"
  },
  "stats": {
    "shoots": "Shoots",
    "shootsHint": "in the next {{days}} days",
    "rolesFilled": "Roles booked",
    "rolesFilledHint": "{{booked}} of {{total}} roles",
    "pencils": "Pencils to confirm",
    "pencilsHint": "holds in the next {{days}} days",
    "attention": "Needs attention",
    "attentionHint": "items waiting for someone",
    "availability": "Availability asks",
    "availabilityHint": "sent, still unanswered"
  },
  "filters": {
    "all": "All",
    "resourcing": "Resourcing",
    "availability": "Availability",
    "callsheets": "Callsheets",
    "bookings": "Bookings"
  },
  "attention": {
    "ariaLabel": "Items that need attention",
    "empty": "Nothing waiting here.",
    "rolesUnfilled": {
      "title_one": "{{count}} unfilled role on {{production}}",
      "title_other": "{{count}} unfilled roles on {{production}}",
      "description": "Shoot starts {{date}}",
      "action": "Find crew"
    },
    "callsheetMissing": {
      "title": "No callsheet for {{production}} yet",
      "description_one": "{{count}} crew member booked",
      "description_other": "{{count}} crew members booked",
      "action": "Open"
    },
    "callsheetBuilding": {
      "title": "Callsheet for {{production}} is not shared yet",
      "description": "Recipients have no call details",
      "action": "Open"
    },
    "availability": {
      "title": "{{resource}} has not answered yet",
      "someone": "This resource",
      "description": "Availability asked for {{range}}",
      "due_one": "waiting {{count}} day",
      "due_other": "waiting {{count}} days",
      "dueToday": "asked today",
      "action": "Open resource"
    },
    "pencils": {
      "title_one": "{{count}} pencilled booking needs confirming",
      "title_other": "{{count}} pencilled bookings need confirming",
      "description": "Holds in the next {{days}} days",
      "due": "This window",
      "action": "Open bookings"
    }
  },
  "timeline": {
    "empty": "No shoots in this window.",
    "unassigned": "No team",
    "crew": "Crew booked {{booked}} / {{total}}",
    "demandTitle": "Crew per day",
    "demandHint": "How many people each day of the window asks for",
    "demandEmpty": "No crew needed in this window.",
    "demandBookedShort": "booked",
    "demandUnfilledShort": "unfilled",
    "demandBooked_one": "{{count}} person booked",
    "demandBooked_other": "{{count}} people booked",
    "demandUnfilled_one": "{{count}} role still unfilled",
    "demandUnfilled_other": "{{count}} roles still unfilled",
    "legend": {
      "active": "Shooting",
      "ready": "Ready",
      "resourcing": "Resourcing",
      "alert": "At risk"
    }
  },
  "workspaces": {
    "shoots_one": "{{count}} shoot in the next {{days}} days",
    "shoots_other": "{{count}} shoots in the next {{days}} days",
    "rolesFilled": "roles booked",
    "attention": "{{value}} to fix",
    "noAttention": "On track",
    "open": "Open",
    "emptyTitle": "No workspaces yet",
    "empty": "This organization has no workspaces yet."
  },
  "loadError": "The dashboard could not be loaded.",
  "demo": {
    "toggle": "See the dashboard's potential",
    "bannerTitle": "You are looking at sample data",
    "bannerMessage": "A busy fortnight, made up to show what this dashboard does once your shoots, crew and callsheets live in Atellio. Links are switched off.",
    "exit": "Back to my data"
  }
}
